import React from "react";
import "../styles/Bilgitoplum.css";
import Reveal from "../components/Reveal";
import faaliyetBelgesi2026 from "../assets/ATSPDF/12 FAALİYET BELGESİ 19.01.2026.pdf";
import bdr2023 from "../assets/ATSPDF/3-BDR-AtsDöviz-2023-İmzalı.pdf";
import bdr2024 from "../assets/ATSPDF/3-BDR-ATSDöviz-2024-İmzalı.pdf";
import bdr2025 from "../assets/ATSPDF/3-BDR-AtsDöviz-2025-İmzalı.pdf";

const rows = [
  ["ŞİRKET TÜRÜ", "A GrubuYetkili Müessese"],
  ["MERSİS", "0097003724700021"],
  ["TİCARET SİCİL NUMARASI", "299267 - 0"],
  ["TİCARET UNVANI", "ATS Döviz Altın Ticareti Yetkili Müessese A.Ş."],
  ["ADRES", "Mimar Kemalettin Mah. Ordu Cad. 63/E Laleli/İst."],
  "HEADER",
  ["TELEFON", "0212 518 50 50"],
  ["E-POSTA", "info@atsdoviz.com.tr"],
  ["KAYITLI SERMAYE", "10.000.000 (On Milyon) TL"],
  ["ÖDENMİŞ SERMAYE", "10.000.000 (On Milyon) TL"],
  ["ŞİRKET TESCİL TARİHİ", "12.05.1993"],
  ["KAYITLI OLDUĞU TİCARET ODASI", "İstanbul Ticaret Odası"],
  ["VERGİ DAİRESİ VE NUMARASI", "Beyazıt V.D. 097 003 72 47"],
  ["YÖNETİM KURULU BAŞKANI", "Selim Erhan Mete"],
  ["GENEL MÜDÜR", "Selim Erhan Mete"],
  ["İÇ KONTROL GÖREVLİSİ", "Reyhan Ustabaşı"],
  ["DENETÇİ / YMM", "EA Yeminli Mali Müşavirlik A. Ş."],
];

const evraklar = [
  {
    id: "sicil-tasdiknamesi",
    baslik: "Sicil Tasdiknamesi",
    dosyaAdi: "Sicil Tasdikname.pdf",
    aciklama: "Şirket sicil tasdiknamesi"
  },
  {
    id: "faaliyet-belgesi",
    baslik: "Faaliyet Belgesi",
    dosyaAdi: "faaliyet-belgesi.pdf",
    aciklama: "Şirket faaliyet belgesi",
    dosyaUrl: faaliyetBelgesi2026
  },
  {
    id: "kurulus-ticaret-sicil",
    baslik: "Kuruluş Ticaret Sicil Gazetesi",
    dosyaAdi: "Kuruluş Ticaret Sicil Gazetesi.pdf",
    aciklama: "Kuruluş ticaret sicil gazetesi"
  },
  {
    id: "sermaye-1997",
    baslik: "14.01.1997 Sermaye Arttırımı",
    dosyaAdi: "14.01.1997 Sermaye Arttırımı.pdf",
    aciklama: "1997 yılı sermaye arttırımı"
  },
  {
    id: "sermaye-1998",
    baslik: "01.10.1998 Sermaye Arttırımı",
    dosyaAdi: "01.10.1998 Sermaye Arttırımı.pdf",
    aciklama: "1998 yılı sermaye arttırımı"
  },
  {
    id: "sermaye-2004",
    baslik: "26.05.2004 Sermaye Arttırımı",
    dosyaAdi: "26.05.2004 Sermaye Arttırımı.pdf",
    aciklama: "2004 yılı sermaye arttırımı"
  },
  {
    id: "sermaye-2019",
    baslik: "26.06.2019 Sermaye Arttırımı",
    dosyaAdi: "26.06.2019 Sermaye Arttırımı.pdf",
    aciklama: "2019 yılı sermaye arttırımı"
  },
  {
    id: "sermaye-2022",
    baslik: "02.09.2022 Sermaye Arttırımı ve Ünvan Değişikliği",
    dosyaAdi: "02.09.2022 Sermaye Arttırımı ve Ünvan Değişikliği.pdf",
    aciklama: "2022 yılı sermaye arttırımı ve ünvan değişikliği"
  },
  {
    id: "pay-devri-2007",
    baslik: "04.04.2007 Pay Devri",
    dosyaAdi: "04.04.2007 Pay Devri.pdf",
    aciklama: "2007 yılı pay devri"
  },
  {
    id: "vergi-levhasi",
    baslik: "Vergi Levhası",
    dosyaAdi: "Vergi Levhası.pdf",
    aciklama: "Şirket vergi levhası"
  },
  {
    id: "yetkili-muessese-belgesi",
    baslik: "Yetkili Müessese Belgesi",
    dosyaAdi: "Yekili Müessese Belgesi.pdf",
    aciklama: "Yetkili müessese belgesi"
  }
];

const bagimsizDenetimRaporlari = [
  {
    id: "bdr-2023",
    baslik: "BAĞIMSIZ DENETİM RAPORU 2023",
    aciklama: "2023 yılı bağımsız denetim raporu",
    dosyaUrl: bdr2023
  },
  {
    id: "bdr-2024",
    baslik: "BAĞIMSIZ DENETİM RAPORU 2024",
    aciklama: "2024 yılı bağımsız denetim raporu",
    dosyaUrl: bdr2024
  },
  {
    id: "bdr-2025",
    baslik: "BAĞIMSIZ DENETİM RAPORU 2025",
    aciklama: "2025 yılı bağımsız denetim raporu",
    dosyaUrl: bdr2025
  }
];

const Bilgitoplum = () => {
  let rowIndex = 0;

  const handleEvrakClick = (evrak: any) => {
    const pdfUrl = evrak.dosyaUrl || `/evraklar/${evrak.dosyaAdi}`;
    window.open(pdfUrl, "_blank");
  };

  return (
    <div className="bilgitoplum-container">
      <Reveal variant="fade-up" duration={600}>
        <table className="bilgitoplum-table">
          <tbody>
            {rows.map((row, idx) => {
              if (row === "HEADER") {
                return (
                  <tr
                    className="bilgitoplum-header-row"
                    key={"header-row"}
                  >
                    <td colSpan={2}>İLETİŞİM BİLGİLERİ</td>
                  </tr>
                );
              } else {
                rowIndex++;
                return (
                  <tr key={idx}>
                    <td>{row[0]}</td>
                    <td>{row[1]}</td>
                  </tr>
                );
              }
            })}
          </tbody>
        </table>
      </Reveal>

      {/* Evraklarımız Bölümü */}
      <div className="evraklar-section">
        <Reveal variant="fade-up" duration={600}>
          <h3 className="evraklar-baslik">EVRAKLARIMIZ</h3>
        </Reveal>
        <div className="evraklar-grid">
          {evraklar.map((evrak, index) => (
            <Reveal key={evrak.id} variant="fade-up" duration={550} delay={index * 60}>
              <div 
                className="evrak-item"
                onClick={() => handleEvrakClick(evrak)}
              >
                <div className="evrak-icon">📄</div>
                <div className="evrak-baslik">{evrak.baslik}</div>
                <div className="evrak-aciklama">{evrak.aciklama}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Bağımsız Denetim Raporları Bölümü */}
      <div className="evraklar-section">
        <Reveal variant="fade-up" duration={600}>
          <h3 className="evraklar-baslik">BAĞIMSIZ DENETİM RAPORLARI</h3>
        </Reveal>
        <div className="evraklar-grid">
          {bagimsizDenetimRaporlari.map((rapor, index) => (
            <Reveal key={rapor.id} variant="fade-up" duration={550} delay={index * 60}>
              <div
                className="evrak-item"
                onClick={() => handleEvrakClick(rapor)}
              >
                <div className="evrak-icon">📄</div>
                <div className="evrak-baslik">{rapor.baslik}</div>
                <div className="evrak-aciklama">{rapor.aciklama}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Bilgitoplum;
